import React from 'react';

function Instructions() {
  return (
    <section className="instructions">
      <h1 className="main-heading">
        <span className="highlight">Unlock Your</span> Personalised Gemstone Guidance 💎
      </h1>
      <p className="instruction-text">
        To receive precise gemstone guidance, please share your basic birth details - Date, Time and Place of Birth. ✨
      </p>
    </section>
  );
}

export default Instructions;
